import React, { useState } from "react";
import { Box, Modal } from "@mui/material";
import ViewFamilyNote from "./ViewFamilyNote";

import DeleteMedicalNote from "./DeleteMedicalNote";
import TypeNoteChip from "../Chips/TypeNoteChip";
import DateAndTimeChipMobile from "../Chips/DateAndTimeChipMobile";
import EditButtonMobile from "../Buttons/EditButtonMobile";
import DeleteButtoMobile from "../Buttons/DeleteButtoMobile";
import EditMedicalNoteMobile from "./EditMedicalNoteMobile";

function MedicalNoteContainerMobile(props) {
  //VARIABLES


  const styleEdit = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleView = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 750,
    height: "auto",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleDeleteModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    height: 260,
    borderRadius: 2,
    bgcolor: "background.paper",
    /*border: "1px solid #000",*/
    boxShadow: 24,
    // p: 4,
  };

  //STATES
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);

  //FUNCTIONS
  const openEditModal = () => {
    setShowEditModal(true);
  };
  const openDeleteModal = () => {
    setShowDeleteModal(true);
  };
  const closeEditModal = () => {
    setShowEditModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };
  const closeViewModal = () => {
    setShowViewModal(false);
  };

  return (
    <div className="notes-wrapper">
      <Modal
        open={showEditModal}
        onClose={closeEditModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleEdit}>
          <EditMedicalNoteMobile
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeEditModal}
            fileLinks={props.fileUrls}
            relationshipFamilyNote={props.relationship}
          />
        </Box>
      </Modal>

      <Modal
        open={showDeleteModal}
        onClose={closeDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDeleteModal}>
          <DeleteMedicalNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeDeleteModal}
          />
        </Box>
      </Modal>

      <Modal
        open={showViewModal}
        onClose={closeViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleView}>
          <ViewFamilyNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeViewModal}
            relationshipFamilyNote={props.relationship}
          />
        </Box>
      </Modal>
      <div className="note-container-mobile">
        <div className="note-container-block-1-mobile">
          <div style={{ marginRight: "5px" }}>
            <TypeNoteChip noteType={props.noteType} />
          </div>
          <DateAndTimeChipMobile date={props.noteDate} />
          <DateAndTimeChipMobile date={props.noteTime} />
        </div>

        <div className="note-container-block-3-mobile">
          <div className="note-container-line-1-mobile">
            <div
              className="note-container-line1-block1bis-mobile left-block"
              style={{
                width: "60%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
              }}
            >
              <div
                className="title-cell-container-mobile-2"
                style={{ width: "50px" }}
              >
                Done by:
              </div>
              <div className="content-cell-container">{props.doneBy}</div>
            </div>

            <div
              className="note-container-line1-block2-mobile centre-block2"
              style={{ width: "40%" }}
            >
              <div className="sub-block-2">
                {/* <ViewButton handleOpen={openViewModal} /> */}
                <EditButtonMobile handleOpen={openEditModal} />
                <DeleteButtoMobile handleOpen={openDeleteModal} />
              </div>
            </div>
          </div>

          <div
            className="note-container-line-1-mobile-bis"
            style={{ width: "100%" }}
          >
            {props.fileUrls && props.fileUrls.length > 0 ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <span
                  className="note-container-line1-block1bis-mobile-fileattached1 left-block-mobile-1"
                  style={{ width: "50%" }}
                >
                  File(s) attached:{" "}
                </span>
                <span
                  className="note-container-line1-block1bis-mobile-fileattached2"
                  style={{ width: "50%" }}
                >
                  {props.fileUrls
                    .map((file, index) => (
                      <a
                        href={file.url}
                        key={index}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {file.name}
                      </a>
                    ))
                    .reduce((prev, curr, index, array) => {
                      return index < array.length - 1
                        ? [prev, ", ", curr]
                        : [prev, curr];
                    }, [])}
                </span>
              </div>
            ) : (
              "No files attached"
            )}
          </div>

          <div
            className="note-container-line-2-mobile"
            style={{ whiteSpace: "pre-wrap" }}
          >
            {props.noteContent}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MedicalNoteContainerMobile;
